<template>
  <div>
    <section>
      <div class="left">
        <detail-entity-info
            v-if="entity.id"
            :entity="entity">
        </detail-entity-info>
        <h2 v-else v-translate>Základní údaje</h2>
      </div>
      <div class="right">
        <div class="field_left">
          <text-input id="localityname"
                      :required="true"
                      v-model="entity.name"
                      ref="nameref"
                      :disabled="!isEditable"
          >
            <translate class="translate">Název</translate>
          </text-input>
          <select-box
              id="operator_detail"
              v-model="entity.id_operator"
              :options="operatorOptions"
              :disabled="!allowSelectOperator"
          >
            <translate class="translate">Operátor</translate>
          </select-box>
          <text-input id="localitycountrycode"
                      v-model="entity.country_code"
                      ref="countrycoderef"
                      :disabled="!isEditable"
                      :help-text="$gettext('ISO 3166-1 alpha-3')"
          >
            <translate class="translate">Kód státu</translate>
          </text-input>
        </div>
        <div class="field_right">
          <textarea-input id="localitydescription"
                          v-model="entity.description"
                          :disabled="!isEditable"
                          rows="6"
                          ref="nameref"
          >
            <translate class="translate">Popis</translate>
          </textarea-input>
        </div>
        <div class="field_left" v-if="showDefaultLocalityCheckbox">
          <CheckboxInput
              id="DefaultLocality"
              v-model="entity.default"
              :disabled="!isEditable"
              :help-text="defaultLocalityHelpText"
          >
            <translate class="translate">Výchozí lokalita</translate>
          </CheckboxInput>
        </div>
        <div :class="{'field_right' : showDefaultLocalityCheckbox, 'field_left': !showDefaultLocalityCheckbox}">
          <CheckboxInput
              id="LocalityMaintenance"
              v-model="entity.maintenance"
              :disabled="!isEditable"
          >
            <translate class="translate">Odstávka lokality</translate>
          </CheckboxInput>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo";
import TextInput from "../../../common/TextInput";
import TextareaInput from "../../../common/TextareaInput";
import CheckboxInput from "../../../common/CheckboxInput";
import formFilterData from "@/components/mixins/form-filter-data";
import requiredFields from "@/components/mixins/required-fields";
import message from "@/components/mixins/message";
import localities from "../mixins/localities";

export default {
  name: "LocalityDetailForm",
  components: {TextInput, TextareaInput, CheckboxInput, DetailEntityInfo},
  mixins: [formFilterData, requiredFields, message, localities],
  props: {
    entity: Object,
    showDefaultLocalityCheckbox: Boolean,
    isEditable: Boolean,
    operatorOptions: Array
  },
  created(LocalityService) {
    this.localityService = LocalityService;
  },
  computed:{
    allowSelectOperator(){
      return this.isEditable && !this.entity.id && this.$_updateActionAllowedAllOrOwnAndGlobal;
    },
    defaultLocalityHelpText(){
      return this.entity.id_operator
          ? this.$gettext('pro operátora')+' '+this.operatorOptions.find(item => item.id == this.entity.id_operator).text
          : this.$gettext('globální');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/localities/locality/LocalityDetailForm.vue